export default __webpack_public_path__ + "static/media/MOLECULAR SPOROFUNGUS.f25ebf07.jpg";